var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2D475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23881 7.13531H13.4741V8.53481H7.23881V7.13531ZM13.4741 9.46631H13.5V13.1467C13.5 13.1467 8.63606 16.6708 4.85831 12.8362C4.85831 12.8362 2.78831 10.737 3.53869 7.67925C3.53869 7.67925 4.13381 3.87056 8.66194 3.40425C8.66194 3.40425 11.4559 3.015 13.2671 5.08837L12.1804 6.15038C12.1804 6.15038 9.8775 3.7665 6.79894 5.63287C6.79894 5.63287 4.28906 7.03181 5.32406 10.5559C5.32406 10.5559 6.46256 13.6136 10.0328 12.9915C10.0328 12.9915 11.2489 12.7148 11.8699 12.1793V10.8658H7.23938V9.46631H13.4741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.98a6b3ba3a80dc6008a1ce791bad390f.svg";
export { ForwardRef as ReactComponent };